import {AbstractService} from 'services/AbstractService';

const PAYERS_LIST_URL = '/api/payers';

export class PayersService extends AbstractService {
  list (accountId) {
    return this.client.get(PAYERS_LIST_URL, {}, {accountId});
  }
}
